/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Image, Typography } from '@doveit/bricks';
import GraphImage from '@graphcms/react-image';
import Link from 'next/link';
import React, { FunctionComponent, useMemo, useCallback } from 'react';
import { Agent } from '../../../domain/graphcms';
import { requireFromStaticAsset } from '../../utils/assetsUtils';
import { buildAgentURLObject, goToPage } from '../../utils/links';
import * as styles from './AgentCard.style';

export interface AgentCardProps {
  agent: Agent,
}

const AgentCard: FunctionComponent<AgentCardProps> = ({
  agent,
}) => {
  const urlObject = useMemo(() => buildAgentURLObject({ slug: agent.slug }), [agent.slug]);

  const onClick = useCallback(
    () => goToPage(urlObject),
    [urlObject],
  );

  const showLink = useMemo(
    () => agent.biography && agent.province,
    [agent],
  );

  return (
    <article
      data-ref="agent-card"
      css={styles.base}
      onClick={showLink && onClick}
    >
      <div css={styles.picture}>
        {agent.photo ? (
          <GraphImage
            image={agent.photo}
            maxWidth={84}
            blurryPlaceholder={false}
            backgroundColor
            fadeIn={false}
          />
        ) : (
          <Image
            src={requireFromStaticAsset('agents/agent-placeholder.svg')}
            alt="Agente Dove.it"
          />
        )}
      </div>
      <div css={styles.info}>
        <div>
          <Typography.BODY>
            <strong>
              {agent.name} {agent.surname}
            </strong>
          </Typography.BODY>
          <Typography.SMALL
            tagName="div"
            color="neutrals.dark"
          >
            {agent.jobTitle}
          </Typography.SMALL>
        </div>
        {showLink && (
          <div css={styles.link}>
            <Link
              href={urlObject.url}
              as={urlObject.as}
            >
              Vedi scheda
            </Link>
          </div>
        )}
      </div>
    </article>
  );
};

export default AgentCard;
